export default __webpack_public_path__ + "static/media/video-1.2b8c3abd.png";